import { PayPalButtons } from "@paypal/react-paypal-js";
import { connect } from "react-redux";
import { push } from "connected-react-router";

// Utils
import { post } from "library/endpoints";

/**
 * PaypalPayment
 * @param {*} props 
 * @returns 
 */
const PaypalPayment = (props) => {
  const createOrder = async () => {
    try {
      let qs = '';
      if (props.promoCodeData) {
        qs += `?code=${props.promoCode}`
      }
    
      const response = await post(`/frontend/payment/create-paypal-order/${props.basket._id}${qs}`);
      return response.data.id
    } catch (error) {
      console.log(error)
    }
  }

  const onApprove = async (data) => {
    try {
      await post(`/frontend/payment/capture-paypal-payment/${props.basket._id}`, data);
      // Redirect to orders
      props.push(`/orders/success`)
    } catch (error) {
      console.log(error)
      props.push(`/orders/fail`)
    }
  }

  return (
    <PayPalButtons
      createOrder={createOrder}
      onApprove={onApprove}
      style={{
        layout: 'horizontal',
      }}
    /> 
  )
}

const stateToProps = state => ({

})

const dispatchToProps = {
  push
}

export default connect(stateToProps, dispatchToProps)(PaypalPayment);